export default __webpack_public_path__ + "689645ea9c5f7936595b81d794ded947.svg";